import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import logoPTS from '../PTS_Logo_jpg.jpg';

/**
 * SIDEBAR SAAS - EVOLUÇÃO EXPERT-AS-A-SERVICE
 * Hierarquia Baseada no Mundo Físico de um Laboratório de Engenharia.
 */
const SidebarSaaS = ({ workspace, allWorkspaces, onOpenAdmin, isVerifyingAdmin, isLocked, isEstudante, onRestrictedClick }) => {
    const { currentUser } = useAuth();

    const [openMenu, setOpenMenu] = React.useState(null);
    const [isSidebarExpanded, setIsSidebarExpanded] = React.useState(true);

    // Auditoria de Cargos (RBAC)
    const isOwner = workspace?.role === 'OWNER' || workspace?.permissao_global === true || workspace?.criado_por === currentUser?.uid;
    const isManager = isOwner || workspace?.role === 'MANAGER';
    const isExtranetView = workspace?.role === 'EXTRANET';

    const lockedNavStyle = isLocked ? {
        pointerEvents: 'none',
        opacity: 0.4,
        userSelect: 'none',
        filter: 'grayscale(100%)'
    } : {};

    // === LÓGICA DE WHITELIST ACADÊMICO ===
    const rotasPermitidasEstudante = ['/chat-ia', '/configuracoes'];
    
    const isRotaRestrita = (rotaTarget) => {
        if (!isEstudante) return false; 
        return !rotasPermitidasEstudante.some(permitida => rotaTarget.includes(permitida));
    };

    const handleNavClick = (e, rotaTarget) => {
        if (isRotaRestrita(rotaTarget)) {
            e.preventDefault(); 
            if (onRestrictedClick) onRestrictedClick(); 
        }
    };

    const getNavStyle = (rotaTarget) => {
        if (isRotaRestrita(rotaTarget)) return { opacity: 0.5, cursor: 'pointer' };
        return {};
    };

    if (!workspace) return null;

    // Componente Auxiliar para Padronização Visual das Categorias
    const MenuCategory = ({ menuKey, icon, label, children, maxHeight = '200px' }) => (
        <div 
            onMouseEnter={() => setOpenMenu(menuKey)} 
            onMouseLeave={() => setOpenMenu(null)}
            style={{ marginBottom: '10px' }}
            title={!isSidebarExpanded ? label : ""}
        >
            <div 
                className="pts-nav-label" 
                onClick={() => setOpenMenu(openMenu === menuKey ? null : menuKey)}
                style={{ 
                    cursor: 'pointer', display: 'flex', paddingRight: '15px',
                    color: openMenu === menuKey ? '#0369a1' : '#94a3b8', transition: 'color 0.2s',
                    justifyContent: !isSidebarExpanded ? 'center' : 'space-between'
                }}
            >
                {!isSidebarExpanded ? icon : `${label.toUpperCase()} ${openMenu === menuKey ? '▼' : '▶'}`}
            </div>
            
            <div style={{ 
                overflow: 'hidden', 
                maxHeight: openMenu === menuKey ? maxHeight : '0', 
                transition: 'max-height 0.3s ease-in-out', 
                paddingLeft: isSidebarExpanded ? '10px' : '0', 
                borderLeft: isSidebarExpanded ? '2px solid #e2e8f0' : 'none', 
                marginLeft: isSidebarExpanded ? '15px' : '0',
                display: 'flex', flexDirection: 'column'
            }}>
                {children}
            </div>
        </div>
    );

    return (
        <aside className={`pts-sidebar ${isSidebarExpanded ? 'expanded' : 'collapsed'}`}>
            <div className="pts-logo-area">
                <img src={logoPTS} alt="Logo PTS" className="pts-logo-img" />
                <div className="pts-brand-column">
                    <h2><span>IA DO ASFALTO</span></h2>
                </div>
            </div>

            <nav className="pts-nav" style={lockedNavStyle}>
                
                {/* SETOR 1: OPERAÇÃO LAB (Técnicos e Laboratoristas) */}
                {!isExtranetView && (
                    <MenuCategory menuKey="operacao" icon="🧪" label="Operação Lab" maxHeight="150px">
                        <NavLink to={`/${workspace.slug}/amostras`} className={({ isActive }) => isActive && !isRotaRestrita('/amostras') ? "active" : ""} onClick={(e) => handleNavClick(e, '/amostras')} style={() => getNavStyle('/amostras')}>
                            <span style={{ fontSize: '1.2rem', marginRight: isSidebarExpanded ? '10px' : '0' }}>📦</span>
                            <span>Gestão de Amostras</span>
                        </NavLink>
                        <NavLink to={`/${workspace.slug}/auditoria`} className={({ isActive }) => isActive && !isRotaRestrita('/auditoria') ? "active" : ""} onClick={(e) => handleNavClick(e, '/auditoria')} style={() => getNavStyle('/auditoria')}>
                            <span style={{ fontSize: '1.2rem', marginRight: isSidebarExpanded ? '10px' : '0' }}>🔬</span>
                            <span>Central de Ensaios</span>
                        </NavLink>
                    </MenuCategory>
                )}

                {/* SETOR 2: ENGENHARIA MEDINA (Gerentes e Sócios) */}
                {!isExtranetView && isManager && (
                    <MenuCategory menuKey="engenharia" icon="📐" label="Engenharia MeDiNa" maxHeight="100px">
                        <NavLink to={`/${workspace.slug}/projetos-dosagem`} className={({ isActive }) => isActive && !isRotaRestrita('/projetos-dosagem') ? "active" : ""} onClick={(e) => handleNavClick(e, '/projetos-dosagem')} style={() => getNavStyle('/projetos-dosagem')}>
                            <span style={{ fontSize: '1.2rem', marginRight: isSidebarExpanded ? '10px' : '0' }}>📑</span>
                            <span>Projetos de Dosagem</span>
                        </NavLink>
                    </MenuCategory>
                )}

                {/* SETOR 3: COMERCIAL E ATIVOS (Gerentes e Sócios) */}
                {!isExtranetView && isManager && (
                    <MenuCategory menuKey="comercial" icon="📈" label="Comercial & Ativos" maxHeight="200px">
                        <NavLink to={`/${workspace.slug}/dashboard`} className={({ isActive }) => isActive && !isRotaRestrita('/dashboard') ? "active" : ""} onClick={(e) => handleNavClick(e, '/dashboard')} style={() => getNavStyle('/dashboard')}>
                            <span style={{ fontSize: '1.2rem', marginRight: isSidebarExpanded ? '10px' : '0' }}>📊</span>
                            <span>Visão Geral</span>
                        </NavLink>
                        <NavLink to={`/${workspace.slug}/empresas`} className={({ isActive }) => isActive && !isRotaRestrita('/empresas') ? "active" : ""} onClick={(e) => handleNavClick(e, '/empresas')} style={() => getNavStyle('/empresas')}>
                            <span style={{ fontSize: '1.2rem', marginRight: isSidebarExpanded ? '10px' : '0' }}>🏢</span>
                            <span>Clientes e Contratos</span>
                        </NavLink>
                        <NavLink to={`/${workspace.slug}/obras`} className={({ isActive }) => isActive && !isRotaRestrita('/obras') ? "active" : ""} onClick={(e) => handleNavClick(e, '/obras')} style={() => getNavStyle('/obras')}>
                            <span style={{ fontSize: '1.2rem', marginRight: isSidebarExpanded ? '10px' : '0' }}>🛣️</span>
                            <span>Gestão de Obras</span>
                        </NavLink>
                    </MenuCategory>
                )}

                {/* VISÃO EXTRANET (Construtoras) */}
                {isExtranetView && (
                    <MenuCategory menuKey="extranet" icon="📂" label="Portal do Cliente" maxHeight="150px">
                        <NavLink to={`/${workspace.slug}/amostras`} className={({ isActive }) => isActive ? "active" : ""}>
                            <span style={{ fontSize: '1.2rem', marginRight: isSidebarExpanded ? '10px' : '0' }}>📦</span>
                            <span>Minhas Amostras</span>
                        </NavLink>
                        <NavLink to={`/${workspace.slug}/meus-laudos`} className={({ isActive }) => isActive ? "active" : ""}>
                            <span style={{ fontSize: '1.2rem', marginRight: isSidebarExpanded ? '10px' : '0' }}>📥</span>
                            <span>Meus Laudos (PDF)</span>
                        </NavLink>
                    </MenuCategory>
                )}

                {/* SETOR 4: DEPARTAMENTO IA (Todos) */}
                {!isExtranetView && (
                    <MenuCategory menuKey="ia" icon="🤖" label="Departamento IA" maxHeight="200px">
                        <NavLink to={`/${workspace.slug}/mesa-tecnica`} className={({ isActive }) => isActive && !isRotaRestrita('/mesa-tecnica') ? "active" : ""} onClick={(e) => handleNavClick(e, '/mesa-tecnica')} style={() => getNavStyle('/mesa-tecnica')}>
                            <span style={{ fontSize: '1.2rem', marginRight: isSidebarExpanded ? '10px' : '0' }}>🤝</span>
                            <span>Mesa Redonda</span>
                        </NavLink>
                        <NavLink to={`/${workspace.slug}/especialistas`} className={({ isActive }) => isActive && !isRotaRestrita('/especialistas') ? "active" : ""} onClick={(e) => handleNavClick(e, '/especialistas')} style={() => getNavStyle('/especialistas')}>
                            <span style={{ fontSize: '1.2rem', marginRight: isSidebarExpanded ? '10px' : '0' }}>👨‍🔬</span>
                            <span>Especialistas</span>
                        </NavLink>
                        <NavLink to={`/${workspace.slug}/chat-ia`} className={({ isActive }) => isActive && !isRotaRestrita('/chat-ia') ? "active" : ""} onClick={(e) => handleNavClick(e, '/chat-ia')} style={() => getNavStyle('/chat-ia')}>
                            <span style={{ fontSize: '1.2rem', marginRight: isSidebarExpanded ? '10px' : '0' }}>💬</span>
                            <span>Chat IA (Tokens)</span>
                        </NavLink>
                    </MenuCategory>
                )}

                {/* SETOR 5: GOVERNANÇA (Apenas Sócios) */}
                {isOwner && !isExtranetView && (
                    <MenuCategory menuKey="gov" icon="🛡️" label="Governança" maxHeight="100px">
                        <button 
                            className="pts-nav-btn-link" 
                            onClick={(e) => {
                                if (isRotaRestrita('/admin')) { e.preventDefault(); if (onRestrictedClick) onRestrictedClick(); } 
                                else { onOpenAdmin(); }
                            }}
                            disabled={isVerifyingAdmin}
                            style={{
                                ...getNavStyle('/admin'), 
                                width: '100%', textAlign: 'left', padding: '10px',
                                justifyContent: !isSidebarExpanded ? 'center' : 'flex-start'
                            }} 
                        >
                            <span style={{ fontSize: '1.2rem', marginRight: isSidebarExpanded ? '10px' : '0' }}>{isVerifyingAdmin ? '⏳' : '⚙️'}</span>
                            {/* CORREÇÃO AQUI: Só renderiza o texto se a barra estiver expandida */}
                            {isSidebarExpanded && (
                                <span>{isVerifyingAdmin ? 'Validando...' : 'Painel de Controle'}</span>
                            )}
                        </button>
                    </MenuCategory>
                )}
            </nav>

            <div className="pts-sidebar-user" style={{ borderTop: 'none', padding: 0, marginTop: 'auto', position: 'relative' }}>
                <button 
                    className="pts-collapse-btn"
                    onClick={() => setIsSidebarExpanded(!isSidebarExpanded)}
                    title={isSidebarExpanded ? "Recolher" : "Expandir"}
                >
                    {isSidebarExpanded ? '◀' : '▶'}
                </button>
            </div>
        </aside>
    );
};

export default SidebarSaaS;